import { render, staticRenderFns } from "./TenderParagraphs.vue?vue&type=template&id=538cb55c"
import script from "./TenderParagraphs.vue?vue&type=script&setup=true&lang=js"
export * from "./TenderParagraphs.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports